<template>
    <div
        class="flex flex-wrap"
        :class="{ 'opacity-50': !cylinder.a || !cylinder.b || hasButton(cylinder) || cylinder.b == 10 }"
    >
        <Listbox as="div" v-model="selected" class="w-full">
            <ListboxLabel class="block text-sm font-bold text-gray-700 mb-1">
                <info-modal title="Paniekfunctie op cilinder" class="text-sm" :infoIcon="true" :body="info"
                    >Paniekfunctie</info-modal
                >
            </ListboxLabel>

            <div class="relative">
                <div
                    v-if="!cylinder.a || !cylinder.b || hasButton(cylinder) || cylinder.b == 10"
                    class="z-20 absolute inset-0 cursor-not-allowed"
                ></div>

                <ListboxButton
                    class="bg-white relative w-full border border-gray-300 rounded-md shadow pl-4 pr-8 text-left cursor-pointer focus:outline-hidden hover:shadow-md transition-shadow"
                    :class="{ 'py-3': categoryFilter, 'py-4': !categoryFilter }"
                >
                    <!-- Ja / Nee -->

                    <span v-if="hasButton(cylinder)" class="flex items-center">
                        <span class="inline-block truncate">Ja</span>
                    </span>
                    <span v-else-if="cylinder.b == 10 || cylinder.a == 10" class="flex items-center">
                        <span class="inline-block truncate">n.v.t.</span>
                    </span>
                    <span v-else-if="selected" class="flex items-center">
                        <span class="inline-block truncate">{{ selected.value }}</span>
                    </span>

                    <span class="absolute inset-y-0 right-0 flex items-center pr-4 pointer-events-none">
                        <fa :icon="['fal', 'angle-down']" class="h-4 w-4 text-gray-400" />
                    </span>
                </ListboxButton>

                <transition name="drop">
                    <ListboxOptions
                        class="absolute z-10 w-full bg-white shadow-lg max-h-[380px] md:max-h-fit -mt-16 rounded-md py-1 text-base ring-1 ring-black/10 overflow-auto focus:outline-hidden"
                    >
                        <ListboxOption
                            as="template"
                            v-for="button in options"
                            :key="button"
                            :value="button"
                            v-slot="{ active, selected }"
                        >
                            <li
                                :class="[
                                    selected || active ? 'bg-gray-100' : 'text-gray-900',
                                    'cursor-default select-none relative py-2 pl-4 pr-2',
                                ]"
                                @click="$emit('update:panic_function', button)"
                                :hidden="hasButton(cylinder) || cylinder.b == 10"
                            >
                                <div
                                    :class="[selected ? 'font-semibold' : 'font-normal', 'block truncate']"
                                    class="flex items-center"
                                >
                                    <img :src="button.image.src" v-if="button.image" class="h-12 inline-block mr-4" />
                                    <div class="h-12" v-else-if="!wizard"></div>
                                    <span>
                                        <span class="text-gray-700 ml-1 block">{{ button.value }}</span>
                                    </span>

                                    <span class="grow text-right">
                                        <span v-if="button.price > 0" class="rounded px-2 py-1 text-xs bg-gray-200 ml-2"
                                            >+ {{ price(button.price) }}</span
                                        >
                                    </span>
                                </div>
                            </li>
                        </ListboxOption>

                        <!-- <div
                            as="template"
                            v-if="hasButton(cylinder) || cylinder.b == 10"
                            class="px-6 py-4 text-sm text-gray-500"
                        >
                            <span>Geen paniekfunctie mogelijk op binnenzijde 10mm.</span>
                        </div> -->
                    </ListboxOptions>
                </transition>
            </div>
        </Listbox>
    </div>
</template>

<script>
import { ref } from 'vue';

export default {
    props: {
        options: Object,
        panic_function: Object | Boolean,
        cylinder: Object,
        info: String,
        index: Number,
        wizard: Boolean,
        categoryFilter: Boolean,
    },

    watch: {
        cylinder: {
            handler(newValue, oldValue) {

                if (newValue.b == 10 || this.hasButton(newValue)) {
                    this.selected = this.options[0];
                    newValue.panic_function = this.options[0];
                }
            },
            deep: true,
        },
    },

    methods: {
        hasButton(cylinder) {
            return (cylinder.button && cylinder.button.value && cylinder.button.value.indexOf('Geen')) || (cylinder.b == 37 || cylinder.a == 37);
        },
    },

    setup(props) {
        const selected = ref(props.panic_function != false ? props.panic_function : props.options[0]);

        return {
            selected,
        };
    },
};
</script>